import { tableSortLabelClasses } from '@mui/material';

export const numericColumnMeta = {
  sx: {
    [`& .${tableSortLabelClasses.root}`]: { justifyContent: 'flex-end', width: '100%' },
    textAlign: 'right',
  },
  bodySx: { textAlign: 'right', fontVariantNumeric: 'tabular-nums' },
} as const;

export const needsReviewRowSx = { borderLeft: '2px solid', borderLeftColor: 'warning.main' } as const;
